<template>
    <WatsonOrganismContentColumnCheckmarks
        :content="content"
        :items="items"
        :heading="heading"
        :headings-position="headingsPosition"
        :column-count="columnCount"
        :turn-on-background="turnOnBackground"
        media-position="next-to-text"
        :background="background"
        :icon-color="iconColor"
        :heading-color="headingColor"
        :text-color="textColor"
        :typography="typography"
    />
</template>

<script setup>
import WatsonOrganismContentColumnCheckmarks from '../../../../components/organisms/content-column-checkmarks/watson-organism-content-column-checkmarks.vue';

defineProps({
    content: {
        type: Object,
        required: true,
    },
    items: {
        type: Array,
        required: true,
    },
    heading: {
        type: String,
        required: false,
        default: null,
    },
    headingsPosition: {
        type: String,
        required: false,
        default: 'left',
    },
    columnCount: {
        type: String,
        required: false,
        default: '1',
    },
    turnOnBackground: {
        type: Boolean,
        required: false,
        default: false,
    },
    background: {
        type: [Object, String],
        required: false,
        default: null,
    },
    iconColor: {
        type: String,
        required: false,
        default: null,
    },
    headingColor: {
        type: String,
        required: false,
        default: null,
    },
    textColor: {
        type: String,
        required: false,
        default: null,
    },
    typography: {
        type: Object,
        required: false,
        default: () => ({}),
    },
});
</script>

<style lang="scss">
@use 'watson-theme-usps';
</style>
